import ExcelReader from './excel-reader/excel-reader.js'
import SheetManager from './sheet-manager/sheet-manager.js'

export default class AzBudgetComponent {
  constructor (params = {}) {
    console.log('AzBudgetComponent constructor')

    this.htmlTemplate = `
      <wp-card>
        <header>
          <h2>AZ Budget</h2>
        </header>
        <section>
          <h3>Upload Budget File</h3>
          <wp-container class="as-row">
            <input type="file" id="file-input" />
            <button type="submit" id="read-file-button" class="button">Upload File</button>
          </wp-container>            
        </section>
      </wp-card>
    `

    this.mountedOn = null
    this.numberPowTen = params.numberPowTen
  }

  mount (element) {
    console.log('AzBudgetComponent mount', element)

    element.innerHTML = this.htmlTemplate
    this.mountedOn = element

    document.body.classList.add('webpaint')

    this.render()
  }

  render () {
    console.log('AzBudgetComponent render')
    if (!this.mountedOn) return

    addListeners(this)
  }
}

function addListeners (instance) {
  console.log('addListeners')
  if (!instance.mountedOn) return

  instance.mountedOn.querySelector('#read-file-button').addEventListener('click', (event) => onReadFileButtonClick(instance, event))
}

async function onReadFileButtonClick (instance, event) {
  console.log('onReadFileButtonClick', event)
  if (!instance.mountedOn) return

  const file = instance.mountedOn.querySelector('#file-input').files[0]
  console.log('file...', file)

  const { cellsTable, groupHeadersMap } = await analyseBudget(instance, file)
  console.log('cellsTable', cellsTable)

  instance.mountedOn.dispatchEvent(new CustomEvent('pp:onBudgetFileRead', {
    detail: { cellsTable, groupHeadersMap },
    bubbles: true
  }))
  console.log('Event dispatched: pp:onBudgetFileRead')
  return cellsTable
}

async function analyseBudget (instance, file) {
  console.log('analyseBudget', instance)
  if (!instance.mountedOn) return

  const excelReader = new ExcelReader()
  await excelReader.readFile(file)
  console.log('excelReader', excelReader)

  const sheetNames = excelReader.getSheetNames()
  console.log('sheetNames', sheetNames)

  const budgetSheetName = excelReader.findSheetname('budget')
  console.log('budgetSheetName', budgetSheetName)

  const budgetCells = excelReader.readCells(budgetSheetName)
  console.log('budgetCells', budgetCells)

  // Update values to certain decimals
  // Number((6764.237999999999).toFixed(4))*Math.pow(10,4)
  const numberPowTen = instance.numberPowTen
  budgetCells.forEach(cell => {
    if (!Number.isFinite(cell.value)) return
    cell.value = Number((cell.value).toFixed(numberPowTen)) * Math.pow(10, numberPowTen)
  })

  // Trim
  budgetCells.forEach(cell => {
    if (typeof cell.value !== 'string') return
    cell.value = String(cell.value).trim()
  })

  const sheetManager = new SheetManager(budgetCells)
  console.log('sheetManager', sheetManager)

  const budgetRows = sheetManager.allRows
  console.log('budgetRows', budgetRows)

  const bigGroupHeaders = sheetManager.filterCells({
    columns: [1],
    minRowNumber: 12,
    rowCellsFilterType: 'AND',
    rowCellsFilter: [
      {
        column: 1,
        value: (cellValue) => String(cellValue).length > 0
      },
      {
        column: 3,
        value: (cellValue) => cellValue === undefined || String(cellValue).length === 0
      }
    ]
  })
  console.log('bigGroupHeaders', bigGroupHeaders)

  function analyseGroupHeaders (sheetManager) {
    const groupHeaders = sheetManager.filterCells({
      columns: [1, 3],
      minRowNumber: 12,
      rowCellsFilterFunction: (rowCells) => {
        // Rate (column E = 5) needs to be a valid number
        const cellB = rowCells.find(rowCell => rowCell.columnLetter === 'B')
        if (!(cellB?.cellIsString())) return false

        // Then one of the other columns needs to be a valid number
        const cellD = rowCells.find(rowCell => rowCell.columnLetter === 'D')
        if (!(cellD?.cellIsString())) return false

        return true
      }
    })
    console.log('groupHeaders', groupHeaders)

    const groupHeadersMap = groupHeaders.reduce((map, cell) => {
      map[cell.r] = map[cell.r] || {
        r: cell.r,
        rowNumber: cell.rowNumber,
        code: null,
        description: null,
        cells: []
      }

      if (cell.columnLetter === 'B') map[cell.r].code = cell.value
      if (cell.columnLetter === 'D') map[cell.r].description = cell.value

      return map
    }, {})
    console.log('groupHeadersMap', groupHeadersMap)

    return {
      groupHeaders,
      groupHeadersMap
    }
  }
  const { groupHeadersMap } = analyseGroupHeaders(sheetManager)

  sheetManager.fillCells({
    columnLetter: 'B',
    relativeRow: -1
  })

  const budgetCellsFiltered = sheetManager.filterCells({
    columns: [1, 3, 4, 5, 6, 7, 8, 9, 10, 15, 19],
    minRowNumber: 12,
    rowCellsFilterFunction: (rowCells) => {
      // Rate (column E = 5) needs to be a valid number
      const cellE = rowCells.find(rowCell => rowCell.columnLetter === 'E')
      if (!cellE?.cellIsNumberNonZero()) return false

      // Then one of the other columns needs to be a valid number
      const cellF = rowCells.find(rowCell => rowCell.columnLetter === 'F')
      const cellG = rowCells.find(rowCell => rowCell.columnLetter === 'G')
      const cellH = rowCells.find(rowCell => rowCell.columnLetter === 'H')
      const cellI = rowCells.find(rowCell => rowCell.columnLetter === 'I')
      const cellJ = rowCells.find(rowCell => rowCell.columnLetter === 'J')
      const cellK = rowCells.find(rowCell => rowCell.columnLetter === 'K')

      const cellsOfInterest = [cellF, cellG, cellH, cellI, cellJ, cellK]
      const hasNonZeroValues = cellsOfInterest.some(cell => cell?.cellIsNumberNonZero())
      if (!hasNonZeroValues) return false

      const hasNumbers = [cellG, cellI, cellK].every(cell => cell?.cellIsNumber())
      if (!hasNumbers) return false

      return true
    }
  })

  const cellsOfInterest = [...budgetCellsFiltered]

  const cellsTable = sheetManager.cellsToTable({
    cells: cellsOfInterest,
    columns: [
      { index: 1, name: 'Code' },
      { index: 3, name: 'Description' },
      { index: 4, name: 'Rate' },
      { index: 5, name: 'PRE-PRODN. Wks' },
      { index: 6, name: 'PRE-PRODN. Amount' },
      { index: 7, name: 'SHOOT Wks' },
      { index: 8, name: 'SHOOT Amount' },
      { index: 9, name: 'POST-PRODN. Wks' },
      { index: 10, name: 'POST-PRODN. Amount' },
      { index: 15, name: 'QAPE' },
      { index: 19, name: 'Stage of Production' }
    ]
  })
  console.log('cellsTable', cellsTable)

  cellsTable.forEach(cell => {
    if (cell.columnName === 'Stage of Production') {
      cell.value = 'Stage of Production'
    }
  })

  return {
    cellsTable,
    groupHeadersMap
  }
}
